const routes = [
    {
        path: "/settings/document-constants",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "constant_show"
        }
    }
];

export default routes;
